import axios from 'axios';
import React, { useState, useEffect } from 'react';
import Select from 'react-dropdown-select';


const CuratedTrendProducts = () => {

  const [products, setProducts] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [gender, setGender] = useState('');
  const [trends, setTrends] = useState('');
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(100);
  const [trendMapping, setTrendMapping] = useState({})
  const [csvFile, setCSVFile] = useState('')
  const [csvFileObj, setCsvFileObj] = useState(null)
  const [csvFileOptions, setCSVFileOptions] = useState([])
  const [trendOptions, setTrendOptions] = useState([]);


  const getAllFileNames = async () => {
    const response = await axios.get('/api/curated-trend-products/filenames');
    setCSVFileOptions(response.data.files)

  }

  useEffect(() => {
    getAllFileNames()
  }, [])


  useEffect(() => {
    const filteredArr = csvFileOptions.find(c => c._id == csvFile)
    if (!filteredArr) {
      setCsvFileObj(null)
    } else {
      setCsvFileObj(filteredArr)
    }
  }, [csvFile])

  useEffect(() => {
    let newTrendOptions = trendMapping[gender] || []
    if (!gender) {
      newTrendOptions = []
      Object.keys(trendMapping).sort().forEach(g => {
        newTrendOptions = [...newTrendOptions, ...trendMapping[g]]
      })
    }
    setTrendOptions(newTrendOptions)
  }, [gender, csvFile, trendMapping]);

  useEffect(() => {
    setTrends([]); // Reset trend when gender changes
    setPage(1);   // Reset to first page
  }, [gender, csvFile]);

  useEffect(() => {
    setPage(1)
  }, [trends])

  useEffect(() => {
    setGender('')
    setTrends([])
  }, [csvFile])

  const fetchProducts = async () => {
    if (!csvFile) {
      setTrends([])
      setProducts([])
      setTotal(0)
      return
    }
    setLoading(true);
    const trend = trends.join(',,')
    try {
      const query = new URLSearchParams({ gender, trend, page, limit, csvFile });
      const res = await fetch(`/api/curated-trend-products?${query}`);
      const data = await res.json();
      setTrendMapping(data.genderTrends)
      setProducts(data.products);
      setTotal(data.total);
    } catch (err) {
      console.error("Fetch error:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProducts();
  }, [csvFile, gender, trends, page, limit]);

  const downloadProductIds = async () => {

    const trend = trends.join(',,')

    const query = new URLSearchParams({ gender, trend, page, limit, csvFile });
    const response = await axios.get(`/api/curated-trend-products/product-ids?${query}`)
    const productIds = response.data.products
    const text = `Gender, Trend name, Product ID, Image URL\n` + productIds.map(prod => `${prod.gender},"${prod.trendName}",${prod.productId},${prod.imageLink}`).join('\n');
    const blob = new Blob([text], { type: "text/plain" });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = `${csvFileObj.filename} Products.csv`;
    document.body.appendChild(a);
    a.click();

    // Clean up
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);

  }

  return (
    <div className="p-8 bg-gray-50 min-h-screen">
      <div className="max-w-7xl mx-auto space-y-6">
        <h1 className="text-2xl font-bold text-gray-800">{csvFileObj ? csvFileObj.filename.split('.csv')[0] : null}</h1>

        {/* Filters Bar */}
        <div className="flex flex-wrap justify-between bg-white p-4 rounded-lg shadow-sm border border-gray-200 w-full">
          {/* Gender Filter */}
          <div className='max-w-full my-1 '>

            <div className='m-1 flex'>
              <label className='text-nowrap font-medium px-2 pt-1'>Select curation file : </label>
              <select
                value={csvFile}
                onChange={(e) => setCSVFile(e.target.value)}
                className="w-full border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 p-2 "
              >
                <option value="" disabled>Select File</option>
                {csvFileOptions.map(v => <option value={v._id}>{v.filename}</option>)}
              </select>
              {!csvFile && false ? <p className='text-red-600 font-medium pl-2'>Please select a file</p> : null}
            </div>
            <div className='flex'>

              {/* Trend Name Filter (Dependent) */}
              <div className='m-1 max-w-[70vw] flex' hidden={!csvFile}>

                <label className='text-nowrap font-medium px-2 pt-1'>Select Trend: </label>
                <div className='w-[40vw]'>
                  <Select
                    multi
                    values={trendOptions.filter(t => trends.includes(t))}
                    options={trendOptions.sort().map(t => ({ name: t }))}
                    labelField="name"
                    valueField='name'
                    placeholder={`${trendOptions.length} Total Trends`}
                    onChange={values => setTrends(values.map(t => t.name))}
                    className=" border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-gray-500 disabled:bg-gray-100 p-2 max-w-full w-full"
                  />
                </div>
              </div>

              <div className='m-1 flex' hidden={!csvFile}>

                <label className='text-nowrap font-medium px-2 pt-1'>Select Gender : </label>
                <select
                  value={gender}
                  onChange={(e) => setGender(e.target.value)}
                  className="w-full border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 p-2"
                >
                  <option value="">Women & Men Merged Curation</option>
                  <option value="Women">Women Curation Only</option>
                  <option value="Men">Men Curation Only</option>
                </select>
              </div>
            </div>
          </div>
          <div className='my-1'>
            <select
              value={limit}
              onChange={(e) => { setLimit(Number(e.target.value)); setPage(1); }}
              className="w-full border-gray-300 rounded-md shadow-sm p-2"
            >
              {[100, 500, 1000, 5000, 10000].map(v => <option key={v} value={v}>{v} per page</option>)}
            </select>
          </div>
          <div className='w-full shrink-0 mt-2' hidden={!csvFile}>
            <button className='primary-btn' onClick={downloadProductIds}>Download Product IDs</button>


          </div>
        </div>

        <div className="flex items-center justify-between">
          <p className="text-sm text-gray-700">
            Showing <span className="font-medium">{(page - 1) * limit + 1}</span> to <span className="font-medium">{Math.min(page * limit, total)}</span> of <span className="font-medium">{total}</span> results
          </p>
          <div className="space-x-2">
            <button
              onClick={() => setPage(p => Math.max(1, p - 1))}
              disabled={page === 1}
              className="px-4 py-2 border rounded-md bg-white hover:bg-gray-50 disabled:opacity-50"
            >
              Previous
            </button>
            <button
              onClick={() => setPage(p => p + 1)}
              disabled={page * limit >= total}
              className="px-4 py-2 border rounded-md bg-white hover:bg-gray-50 disabled:opacity-50"
            >
              Next
            </button>
          </div>
        </div>

        <div className="bg-white flex flex-wrap justify-start">
          {loading ? (
            <div className='p-20 flex justify-center items-center'>
              <div colSpan="3" className="px-6 py-4 text-center">Loading...</div>
            </div>
          ) : products.map(p => (
            <div key={p._id} className='w-1/6 p-1  m-0'>
              <div className='bg-gray-50 p-2 rounded'>
                <div className="flex justify-center">
                  <img loading='lazy' className='h-40 max-w-full border border-gray-200' src={p.imageLink} />
                </div>
                <div className="text-sm font-mono ">
                  <a
                    href={`https://www.ajio.com/p/${p.productId}`}
                    target='_blank'
                    className='text-blue-500 hover:text-blue-700'
                  > {p.productId}
                  </a>
                </div>
                <div className="text-sm text-gray-600">{p.gender}</div>
                <div className="text-sm text-gray-600">{p.trendName}</div>
              </div>
            </div>
          ))}
        </div>

        {/* Pagination Controls */}
        <div className="flex items-center justify-between">
          <p className="text-sm text-gray-700">
            Showing <span className="font-medium">{(page - 1) * limit + 1}</span> to <span className="font-medium">{Math.min(page * limit, total)}</span> of <span className="font-medium">{total}</span> results
          </p>
          <div className="space-x-2">
            <button
              onClick={() => setPage(p => Math.max(1, p - 1))}
              disabled={page === 1}
              className="px-4 py-2 border rounded-md bg-white hover:bg-gray-50 disabled:opacity-50"
            >
              Previous
            </button>
            <button
              onClick={() => setPage(p => p + 1)}
              disabled={page * limit >= total}
              className="px-4 py-2 border rounded-md bg-white hover:bg-gray-50 disabled:opacity-50"
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CuratedTrendProducts
